// extracted by mini-css-extract-plugin
export var language = "language-matrix-module--language--3b4f9";
export var note = "language-matrix-module--note--406eb";
export var subFeature = "language-matrix-module--subFeature--e5edf";